export default __webpack_public_path__ + "static/Montserrat-Light-680066c40fec5577192c1df513a88521.eot";